import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdminDestinationService {

  serviceBaseURL: string = '';

  constructor(private http: HttpClient) {
    this.serviceBaseURL = environment.serviceBaseUrl;
  }

  getDestination(): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/GetDestination').toPromise();
  }

  addDestination(destinationObj): Promise<any> {
    return this.http.post(this.serviceBaseURL + 'Kesavi/AddAdminToursDestination', destinationObj).toPromise();
  }

  editDestination(destinationObj): Promise<any> {
    return this.http.post(this.serviceBaseURL + 'Kesavi/UpdateAdminToursDestination', destinationObj).toPromise();
  }

  deleteDestinationByID(ID): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/DeleteDestionation/' + ID).toPromise();
  }


}
